<template>
  <div class="organization">
    <page-header :title="organization.name">
      <div slot="sub-title">
        <i class="el-icon-location"></i>
        {{ organization.address }}, {{ organization.zip }} - {{ organization.city }}, {{ organization.country.name }}
      </div>
    </page-header>

    <el-row :gutter="20" class="body-padding mobile-padding">
      <el-col :md="15" :lg="17" class="" v-loading="loading">
        <list-container :organization="organization" @refresh="getOrganization" />
      </el-col>
      <el-col :md="9" :lg="7">
        <el-card class="no-padding">
          <organization-details :organization="organization" @edit="showDialog = true" />
        </el-card>
        <el-card class="no-padding" style="margin-top: 20px;">
          <subscription :organization="organization" />
        </el-card>
      </el-col>   
    </el-row>

    <el-dialog :append-to-body="true" :visible.sync="showDialog" :show-close="false" width="450px" top="1.5vh" custom-class="dialog-no-padding dialog-invert full-width-mobile">
      <organization-upsert-form
          :organization="organization"
          @updated="handleUpdated"
          v-if="showDialog" />
    </el-dialog>

  </div>
</template>

<script>
import OrganizationDetails from './OrganizationDetails'
import OrganizationUpsertForm from '@/components/dashboard/organizations/UpsertForm'
import StatCard from '@/components/shared/StatCard'
import StationMap from '@/components/dashboard/stations/map/StationMap'
import ListContainer from './lists/ListContainer'
import Subscription from './Subscription'

export default {
  name: 'Organization',
  components: {
    Subscription,
    OrganizationDetails,
    OrganizationUpsertForm,
    StatCard,
    StationMap,
    ListContainer
  },
  data () {
    return {
      organization: {
        name: '',
        users: [],
        stations: [],
        prices: [],
        groups: [],
        country: {
          name: ''
        }
      },
      showDialog: false,
      loading: true
    }
  },
  methods: {
    handleUpdated (organization) {
      this.organization = organization
      this.showDialog = false
    },
    async getOrganization () {
      const response = await this.$http.get(this.$api.organizations.get(this.$route.params.orgId))
      this.organization = response.data
      this.loading = false
    }
  },
  created () {
    this.getOrganization()
  }
}
</script>

<style lang="scss" scoped>
  .body-padding {
    padding-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/Organization.vue